<lib-modal-layout [title]="data.title || 'Confirm Action'" [subtitle]="data.subtitle || ''">
  <p class="text-center">
    {{ data.message || 'Are you sure you want to proceed with this action?' }}
  </p>
  <form [formGroup]="form">
    <div class="mb-3">
      <lib-form-text
        [label]="'Please type '+ data.confirmString + ' to confirm.'"
        formControlName="confirmInput"
        type="text"
      ></lib-form-text>
    </div>
  </form>
  <div class="text-center" btnPrimary>
    <lib-button
      [cssType]="'btn-primary'"
      [text]="data.confirmButtonText"
      [type]="'button'"
      (click)="onConfirm()"
      [disabled]="form.invalid"
    ></lib-button>
  </div>
</lib-modal-layout>
